<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">
        Mis {{ tituloPlural() }}
      </h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-0 p-md-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        @if (error().length > 0) {
          <div class="alert alert-danger mt-0" role="alert">
            <small>{{ error() }}</small>
          </div>
        }

        @if (message().length > 0) {
          <div class="alert alert-success mt-0" role="alert">
            <small>{{ message() }}</small>
          </div>
        }

        <div class="d-grid mt-0 mb-3 pb-3">
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0"
            [routerLink]="['/my-account-ubicacion']"
            [disabled]="loading()"
          >
            {{ loading() ? 'Cargando...' : ('Agregar ' + tituloSingular()) }}
          </button>
        </div>
        <span class="p-0 m-0">
          <b>{{ tituloPlural() }} ({{ ubicaciones().length }})</b>
        </span>

        @for (ubicacion of ubicaciones(); track ubicacion.id) {
          <div class="ubicacion-card mt-3 form-switch">
            <a
              class="text-decoration-none text-dark flex-grow-1 overflow-hidden"
              [routerLink]="['/my-account-edit-ubicacion/' + ubicacion.id]"
            >
              <div class="ubicacion-title">
                {{ ubicacion.x_domicilio }}
              </div>

              @if (ubicacion.x_piso_dpto) {
                <div class="ubicacion-subtitle">
                  {{ ubicacion.x_piso_dpto }}
                </div>
              }

              @if (ubicacion.x_codigo_postal) {
                <div class="ubicacion-extra">
                  CP: {{ ubicacion.x_codigo_postal }}
                </div>
              }

              @if (ubicacion.x_telefono) {
                <div class="ubicacion-extra">
                  Tel: {{ ubicacion.x_telefono }}
                </div>
              }

              @if (ubicacion.b_default) {
                <div class="ubicacion-badge">
                  Predeterminada
                </div>
              }
            </a>

            <div class="col-2">
              <a
                class="ubicacion-action"
                [routerLink]="['/my-account-edit-ubicacion/' + ubicacion.id]"
              >
                <i class="bi bi-pencil"></i>
              </a>
            </div>

            <div class="col-auto">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="ubicacion.id"
                [checked]="ubicacion.b_activo"
                (click)="activarDesactivar($event)"
              />
            </div>
          </div>
        } @empty {
          <div class="empty-state mt-4">
            <i class="bi bi-geo-alt"></i>

            <div class="empty-title">
              No tenés {{ tituloPlural().toLowerCase() }} cargadas
            </div>

            <div class="empty-subtitle">
              Agregá una ubicación para continuar.
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
